import { Flow_0_0_2, getFullItemTwo, MakeServerCall, getCurrentUser } from '@flexus/core';
import { map, pluck, skipWhile, take } from 'rxjs/operators';
import { UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';

export const SP_CONTEXT_MENU_JOB_NOTES: Flow_0_0_2 = {
	id: 'AddNote',
	itemType: 'flow',
	includeForOnlyStates: ['all'],
	name: 'View Notes',
	header: {
		title: (store, bf) => {
			return store.select(getFullItemTwo).pipe(
				map(itemTwo => {
					if (itemTwo) {
						if (itemTwo?.claim?.applicant) {
							return `View Notes: ${itemTwo?.claim?.loan_information?.mavenclaimnumber} - ${itemTwo?.claim?.applicant?.surname}`;
						} else {
							return 'View Notes:';
						}
					}
				})
			);
		},
		controls: () => () => []
	},

	footer: {
		type: 'node_nav'
	},
	actionPanel: instance => {
		return () => {
			return [{}];
		};
	},
	startNode: 'Notes',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	serverCalls: {
		username: {
			errorMessage: 'No user found.',
			directCall: (http, store) =>
				store.select(getCurrentUser).pipe(
					skipWhile(x => !x),
					take(1),
					map((user: any) => {
						return user?.user?.full_name ?? '';
					})
				)
		},
		notes: {
			serviceVariable: 'spService',
			functionName: 'getNotes',
			responseSlice: 'payload',
			errorMessage: 'No job notes could be found!'
		}
	},
	nodes: {
		Notes: {
			component: 'NotesComponent',
			inputs: {
				title: 'Add Note',
				location: 'context-menu',
				formInputs: {
					0: {
						formControlName: 'message',
						inputType: 'textarea',
						label: 'Add Note',
						placeholder: 'Type a note'
					}
				},
				submitFunction: instance => {
					instance._store.dispatch(
						new MakeServerCall({
							dataKey: 'notes',
							serviceVariable: 'spService',
							functionName: 'addJobNote',
							errorMessage: 'Could not add note'
						})
					);
					instance?.bf?.bigForm?.patchValue({ message: '' });
					instance?.bf?.bigForm?.markAsPristine();
				}
			},
			initFormFields: (bf, item, instance) => {
				bf.bigForm.addControl('message', new UntypedFormControl('', Validators.required));
			}
		}
	}
};
